import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import scrollToComponent from 'react-scroll-to-component';
import { FormattedMessageWrappedInSpan } from '../components/misc';
import { Redirect } from 'react-router-dom';

import EventOnlineView from '../components/content/event/EventOnlineView';
import Faq from '../components/content/Faq';
import InsufficientResultsInformation from '../components/content/informations/InsufficientResultsInformation';
import SecondFactorErrorMsg from '../components/messages/SecondFactorErrorMsg';
import LoadingView from '../components/content/LoadingView';
import MediaList from '../components/content/lists/MediaList';
import ParticipantMediaList from '../components/content/lists/ParticipantMediaList';
import SearchInstructionsDialog from '../components/content/dialogs/SearchInstructionsDialog';

import { hasMedia, hasEnoughMedia, getFotoFlat, getSinglePhoto } from '../utils/common';
import { setCustomerKey } from '../utils/browser-storage';
import { trackEvent } from '../utils/ga-tracking';

class EventSnSearchPage extends Component {
  constructor(props) {
    super(props);

    const { event } = props.viewer;
    var initialSelectedTab;
    switch (true) {
      case event.searchDual:
        initialSelectedTab = 3;
        break;
      case event.smartSearch && hasMedia(event.participant):
        initialSelectedTab = 0;
        break;
      default:
        initialSelectedTab = 1;
    }

    this.state = {
      isLoading: false,
      extendedSearchSelectedTab: initialSelectedTab,
      extendedSearchExpand: false,
      showSearchInstructionsDialog: this._shouldShowSearchInstructionsDialog(),
      shouldLoadImpressions: false,
      // attemptsCount: 0,
    };

    this._refetchMediaForNewStartnumber = this._refetchMediaForNewStartnumber.bind(this);
    this.handleScrollToImpressions = this.handleScrollToImpressions.bind(this);
    this.handleScrollToVoucher = this.handleScrollToVoucher.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.isLoading) {
      return {
        extendedSearchSelectedTab: hasMedia(nextProps.viewer.event.participant) ? 0 : 1,
      };
    }
    return null;
    // if (!prevState.isLoading) {
    //   if (nextProps.viewer.event.participant.media.mediaInfo.count === 0) {
    //     return { attemptsCount: prevState.attemptsCount + 1 };
    //   }
    // }
    // return null;
  }

  componentDidMount() {
    this._scrollToMediaSection();

    const { viewer, snFromUrl, customerKey } = this.props;
    if (customerKey && viewer.event.participant) {
      setCustomerKey(viewer.event.sgId, snFromUrl, customerKey);
    }

    //in case we don't get the callback from MediaListMasonry
    this.imagesLoadedFallback = setTimeout(this.handleImagesLoaded, 5000);

    // track if no media where found
    if (!hasMedia(viewer.event.participant)) {
      this._trackNoMediaFound(snFromUrl);
    }
  }

  componentDidUpdate(prevProps) {
    const { snFromUrl, customerKey } = this.props;
    if (snFromUrl !== prevProps.snFromUrl || customerKey !== prevProps.customerKey) {
      this._refetchMediaForNewStartnumber(snFromUrl, customerKey);
    }
  }

  componentWillUnmount() {
    this.clearImagesLoadedFallback();
  }

  handleExtendedSearchTabChanged = (event, value) => {
    this.setState({
      extendedSearchSelectedTab: value,
      extendedSearchExpand: true,
    });
  };

  handleExtendedSearchExpand = () => {
    this.setState(prevState => ({
      extendedSearchExpand: !prevState.extendedSearchExpand,
    }));
  };

  handleSearchTriggered = () => {
    this.setState({ extendedSearchExpand: false });
  };

  handleDeepSearchBtnClicked = () => {
    this.scrollToExtendedSearch(0);
  };

  handleCategorySearchBtnClicked = () => {
    this.scrollToExtendedSearch(1);
  };

  handleGpsSearchBtnClicked = () => {
    this.scrollToExtendedSearch(2);
  };

  handleScrollToImpressions() {
    scrollToComponent(this.impressions, { align: 'top' });
  }

  handleScrollToVoucher() {
    scrollToComponent(this.voucher, { align: 'middle' });
    trackEvent('Event', 'Voucher', 'Offer Foto-Flat');
  }

  clearImagesLoadedFallback = () => {
    if (this.imagesLoadedFallback) {
      clearTimeout(this.imagesLoadedFallback);
      this.imagesLoadedFallback = null;
    }
  };

  handleImagesLoaded = () => {
    if (!this.state.shouldLoadImpressions) {
      this.clearImagesLoadedFallback();
      this.setState({
        shouldLoadImpressions: true,
      });
    }
  };

  scrollToExtendedSearch(selectedTabIndex) {
    scrollToComponent(this.eventOnlineView);
    this.setState({
      extendedSearchExpand: true,
      extendedSearchSelectedTab: selectedTabIndex,
    });
  }

  _refetchMediaForNewStartnumber(newStartnumber, customerKey) {
    this.setState({ isLoading: true });
    this.props.relay.refetch(
      { startnumber: newStartnumber, secondFactor: customerKey },
      null,
      () => {
        this.setState({
          isLoading: false,
          showSearchInstructionsDialog: this._shouldShowSearchInstructionsDialog(),
        });
        const { viewer, snFromUrl, customerKey } = this.props;
        if (customerKey && viewer.event.participant && !viewer.event.searchByFace) {
          setCustomerKey(viewer.event.sgId, snFromUrl, customerKey);
        }

        // track if no media were found
        if (!hasMedia(viewer.event.participant)) {
          this._trackNoMediaFound(snFromUrl);
        }
      }
    );
  }

  _shouldShowSearchInstructionsDialog() {
    const { participant, products, warnText } = this.props.viewer.event;
    return (
      !hasEnoughMedia(
        participant && participant.media.mediaInfo.count,
        getFotoFlat(products),
        getSinglePhoto(products)
      ) && Boolean(warnText)
    );
  }

  _scrollToMediaSection() {
    if (this.mediaSection) {
      scrollToComponent(this.mediaSection, { align: 'top' });
    }
  }


  _trackNoMediaFound(startNumber) {
    trackEvent('Event', 'Search', 'No photos found for start number', {
      nonInteraction: true,
    });
  }

  render() {
    const { viewer, snFromUrl, customerKey } = this.props;
    const { event } = viewer;

    if (event.legacy) {
      window.location.href = `https://archive.sportograf.com/shop/search/${event.sgId}/${event.participant.startnumber}`;
      return null;
    }

    if (event.state === 'reminder') {
      return <Redirect to={`/event/${event.sgId}`} />;
    }

    const {
      extendedSearchSelectedTab,
      extendedSearchExpand,
      isLoading,
      showSearchInstructionsDialog,
      shouldLoadImpressions,
      // attemptsCount,
    } = this.state;

    const participantMediaCount = event.participant
      ? event.participant.media.mediaInfo.count
      : 0;
    const { count: impressionMediaCount } = event.impressionMedia.mediaInfo;

    return (
      <div className="container-960 container-page">
        <EventOnlineView
          ref={view => (this.eventOnlineView = view)}
          onlineEvent={event}
          urlSn={snFromUrl}
          customerKey={customerKey}
          extendedSearchSelectedTab={extendedSearchSelectedTab}
          extendedSearchExpand={extendedSearchExpand}
          hasSmartSearchTab={event.smartSearch && participantMediaCount !== 0}
          hasGpsSearchTab={event.gps}
          hasExtendedSearch={event.participant !== null}
          hasDualSearchTab={event.searchDual}
          showSearchInstructionsDialog={showSearchInstructionsDialog}
          onExtendedSearchTabChange={this.handleExtendedSearchTabChanged}
          onExtendedSearchExpand={this.handleExtendedSearchExpand}
          onSearchTrigger={this.handleSearchTriggered}
        />
        <div
          ref={div => {
            this.mediaSection = div;
          }}
        >
          {isLoading && <LoadingView />}
          {!isLoading && (
            <>
              {!event.participant && (
                <SecondFactorErrorMsg event={event} />
              )}
              {event.participant && participantMediaCount !== 0 && (
                <Fragment>
                  <div className="row">
                    <div className="col-xs-16 col-sm-12 col-sm-offset-2">
                      <h1 className="separator">
                        {event.searchByFace && (
                          <FormattedMessageWrappedInSpan
                            id="eventSnSearchPage.searchByFace.participantSubtitle"
                            defaultMessage="We found {count, plural, one {# photo} other {# photos}} related to your photo"
                            values={{ count: participantMediaCount }}
                          />
                        )}
                        {!event.searchByFace && (
                          <FormattedMessageWrappedInSpan
                            id="eventSnSearchPage.participantSubtitle"
                            defaultMessage="We found {count, plural, one {# photo} other {# photos}} related to your start number"
                            values={{ count: participantMediaCount }}
                          />
                        )}
                      </h1>
                    </div>
                  </div>
                  <ParticipantMediaList
                    eventHasSearchByFace={event.searchByFace ? true : false}
                    eventHasSecondFactor={event.secondFactorType ? true : false}
                    eventId={event.sgId}
                    startnumber={event.participant.startnumber}
                    customerKey={customerKey}
                    hasMorePhotosButton={
                      participantMediaCount <= event.morePhotosButtonCount
                    }
                    participantMedia={event.participant.media}
                    offer={event}
                    participantMediaCount={participantMediaCount}
                    impressionMediaCount={impressionMediaCount}
                    onScrollToImpressions={this.handleScrollToImpressions}
                    onScrollToVoucher={this.handleScrollToVoucher}
                    onScrollToExtendedSearch={() => this.scrollToExtendedSearch(extendedSearchSelectedTab)}
                    onImagesLoaded={this.handleImagesLoaded}
                  />
                </Fragment>
              )}
              {event.participant && participantMediaCount < 6 && (
                <InsufficientResultsInformation
                  count={participantMediaCount}
                  raceResultsUrl={event.hostResultUrl}
                  showGpsSearchLink={event.gps}
                  showSmartSearchLink={event.smartSearch}
                  tagWithStartNumber={!event.searchByFace}
                  onDeepSearchClick={this.handleDeepSearchBtnClicked}
                  onCategorySearchClick={this.handleCategorySearchBtnClicked}
                  onGpsSearchClick={this.handleGpsSearchBtnClicked}
                />
              )}
              {event.voucherCampaign && event.voucherCampaign.longText && (
                <React.Fragment>
                  <div className="row">
                    <h1 className="separator col-xs-16 col-sm-12 col-sm-offset-2" />
                  </div>
                  <div className="row mb-30" ref={div => (this.voucher = div)}>
                    <div className="voucher-container col-xs-16 col-sm-8 col-sm-offset-4">
                      <div
                        className="voucher-text"
                        dangerouslySetInnerHTML={{
                          __html: event.voucherCampaign.longText,
                        }}
                      />
                      <div className="voucher-banner">
                        <a
                          href={event.voucherCampaign.url}
                          onClick={() => trackEvent('Event', 'Voucher', 'Banner Foto-Flat')}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={event.voucherCampaign.banner} />
                        </a>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )}
              {event.participant && impressionMediaCount > 0 && shouldLoadImpressions && (
                <div ref={div => (this.impressions = div)}>
                  <div className="row">
                    <div className="col-xs-16 col-sm-12 col-sm-offset-2">
                      <h1 className="separator">
                        <FormattedMessageWrappedInSpan
                          id="eventSnSearchPage.impressionSubtitle"
                          defaultMessage="This event has {count, plural, one {# impression} other {# impressions}}"
                          values={{ count: impressionMediaCount }}
                        />
                      </h1>
                    </div>
                  </div>
                  <MediaList
                    eventHasSearchByFace={event.searchByFace ? true : false}
                    eventHasSecondFactor={event.secondFactorType ? true : false}
                    media={event.impressionMedia.mediaList}
                    offer={event}
                    impressionMediaCount={impressionMediaCount}
                    participantMediaCount={participantMediaCount}
                    listType="impressions"
                    startnumber={event.participant.startnumber}
                    onScrollToImpressions={this.handleScrollToImpressions}
                    onScrollToVoucher={this.handleScrollToVoucher}
                    onScrollToExtendedSearch={() => this.scrollToExtendedSearch()}
                  />
                </div>
              )}
            </>
          )}
        </div>
        <Faq
          eventHasSearchByFace={event.searchByFace ? true : false}
          onFindMore={() => this.scrollToExtendedSearch()}
        />
        <SearchInstructionsDialog
          open={showSearchInstructionsDialog}
          message={event.warnText}
          onAccept={() => this.setState({ showSearchInstructionsDialog: false })}
        />
      </div>
    );
  }
}

EventSnSearchPage.propTypes = {
  snFromUrl: PropTypes.string,
  customerKey: PropTypes.string,
  viewer: PropTypes.object,
  relay: PropTypes.object,
};

export { EventSnSearchPage };

export default createRefetchContainer(
  EventSnSearchPage,
  {
    viewer: graphql`
      fragment EventSnSearchPage_viewer on Viewer {
        event(id: $eventId, language: $language) {
          id
          sgId
          gps
          legacy
          hostResultUrl
          impressionMedia {
            mediaInfo {
              count
            }
            mediaList(first: 100) {
              ...MediaList_media
            }
          }
          morePhotosButtonCount
          participant(startnumber: $startnumber, secondFactor: $secondFactor) {
            media {
              mediaInfo {
                count
              }
              ...ParticipantMediaList_participantMedia
            }
            startnumber
          }
          products {
            id
            mediaCollection {
              name
            }
            price
            type
          }
          secondFactorType {
            type
          }
          searchByFace
          searchDual
          smartSearch
          state
          voucherCampaign {
            banner
            longText
            url
          }
          warnText
          ...EventOnlineView_onlineEvent
          ...ParticipantMediaList_offer
          ...MediaList_offer
        }
      }
    `,
  },
  graphql`
    query EventSnSearchPageRefetchQuery(
      $eventId: ID!
      $startnumber: ID!
      $count: Int!
      $cursor: String
      $language: String
      $secondFactor: String
      $individualPart: String
    ) {
      viewer {
        ...EventSnSearchPage_viewer
      }
    }
  `
);
